import { render, staticRenderFns } from "./register.vue?vue&type=template&id=ac73d59e&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&id=ac73d59e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac73d59e",
  null
  
)

component.options.__file = "src/demo/pages/register/register.vue"
export default component.exports